import { atomWithReset } from "jotai/utils";

export const payoutStatusModalAtom = atomWithReset<{
  visible: boolean;
  orderId: string | null;
}>({
  visible: false,
  orderId: null
});
